<template>
    <td class="p-0">
        <template v-if="fieldData.options !== false">
            <span v-if="field_type === 'Boolean'">
                <o-filter-boolean-field
                    class="rounded-0 px-0"
                    :field-name="field.key"
                    :qbe="qbe"
                    v-bind="fieldData.options"
                    @input="filter_changed"
                    @filter="filter_changed"
                ></o-filter-boolean-field>
            </span>
            <span v-if="field_type === 'Date'">
                <o-filter-date-field
                    class="rounded-0 px-0"
                    :field-name="field.key"
                    :qbe="qbe"
                    v-bind="fieldData.options"
                    @input="filter_changed"
                    @filter="filter_changed"
                ></o-filter-date-field>
            </span>
            <span v-if="field_type === 'String'">
                <o-filter-text-field
                    class="rounded-0 px-0"
                    :field-name="field.key"
                    :qbe="qbe"
                    v-bind="fieldData.options"
                    @filter="filter_changed"
                ></o-filter-text-field>
            </span>
            <span v-if="field_type === 'Number'">
                <o-filter-number-field
                    class="rounded-0 px-0"
                    :field-name="field.key"
                    :qbe="qbe"
                    v-bind="fieldData.options"
                    @filter="filter_changed"
                ></o-filter-number-field>
            </span>
            <span v-if="field_type === 'ForeignKey'">
                <o-filter-select
                    blank-option-text=""
                    name="client"
                    :field-name="field.key"
                    :qbe="qbe"
                    value-field="id"
                    v-bind="fieldData.options"
                    @filter="filter_changed"
                >
                    <template #first>
                        <option :value="null"></option>
                    </template>
                </o-filter-select>
            </span>
        </template>
    </td>
</template>

<script>
import OFilterBooleanField from "./OFilterBooleanField.vue";
import OFilterNumberField from "./OFilterNumberField.vue";
import OFilterSelect from "./OFilterSelect.vue";
import OFilterDateField from "./OFilterDateField.vue";
import OFilterTextField from "./OFilterTextField.vue";

export default {
    name: "FilterCell",
    components: {
        OFilterDateField,
        OFilterSelect,
        OFilterNumberField,
        OFilterTextField,
        OFilterBooleanField,
    },
    props: {
        field: { type: Object },
        schema: { type: Object },
        options: { type: Object },
        qbe: { type: Object },
    },
    computed: {
        fieldData() {
            var result = {
                ...this.field,
                schema: this.schema.fields[this.field.key],
                options: {},
            };

            if (this.options && this.field.key in this.options) {
                result.options = this.options[this.field.key];
            }
            return result;
        },
        field_type() {
            if (this.field.key in this.schema.fields) {
                return this.schema.fields[this.field.key].field_type || "";
            } else {
                return "";
            }
        },
    },
    methods: {
        filter_changed($event) {
            this.$emit("filter", $event);
        },
    },
};
</script>
